module.exports = __webpack_public_path__ + "img/5.64b1aa57.png";